export default __webpack_public_path__ + "static/spot-sugar__core-360-paid-04-3e02928018a8f345dd97ad1567bd2112.jpg";